module.exports = __webpack_public_path__ + "img/logo.240a7bb2.svg";